import FullScreenButton from "./FullScreenButton";

export default FullScreenButton;
